import { createApi } from '@reduxjs/toolkit/query/react'

import { customAuthorizedQuery } from 'state/api'

import { apiLinks } from 'constants/api'

import {
  GetLettersInput,
  DeleteLetterInput,
  GetLettersResponse,
  DeleteLetterResponse,
  DownloadLetterResponse,
} from './types'

export const letterApi = createApi({
  reducerPath: 'letterApi',
  baseQuery: customAuthorizedQuery({
    baseUrl: apiLinks.BASE_URL,
  }),
  tagTypes: ['Letters'],
  refetchOnReconnect: true,
  endpoints: (builder) => ({
    getLetters: builder.query<GetLettersResponse, GetLettersInput>({
      query: ({ page, limit }) => ({
        url: apiLinks.letter.getAll,
        method: 'GET',
        params: { page, limit },
      }),
      providesTags: ['Letters'],
    }),
    deleteLetter: builder.mutation<DeleteLetterResponse, DeleteLetterInput>({
      query: ({ id }) => ({
        url: apiLinks.letter.delete(id),
        method: 'DELETE',
      }),
      invalidatesTags: ['Letters'],
    }),
    downloadLetter: builder.mutation<DownloadLetterResponse, { id: string }>({
      queryFn: async ({ id }, _api, _extraOptions, baseQuery) => {
        const result = await baseQuery({
          url: apiLinks.letter.download(id),
          method: 'GET',
          responseType: 'blob',
        })

        if (result.error) {
          return { error: result.error }
        }

        const blob = result.data as Blob
        const headers = (result.meta as any)?.headers
        const contentDisposition = headers?.['content-disposition']

        let filename = `letter-${id}.pdf`
        if (contentDisposition) {
          const match = contentDisposition.match(/filename="(.+)"/)
          if (match) {
            filename = match[1]
          }
        }

        const url = window.URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = filename
        document.body.appendChild(a)
        a.click()
        window.URL.revokeObjectURL(url)
        document.body.removeChild(a)

        return { data: blob }
      },
    }),
  }),
})

export const { useGetLettersQuery, useDeleteLetterMutation, useDownloadLetterMutation } = letterApi
